import { createReducer, on } from '@ngrx/store';
import * as fromStudentActions from '../actions/student.action';
export const featureKey = 'students';

export interface State {
    students: {
        data: Array<any>,
        isLoaded: Boolean
    };
    studentFees: {
        data: Array<any>,
        isLoaded: Boolean
    };
    studentPreinlistments: {
        data: Array<any>,
        isLoaded: Boolean
    };
    gradeConverions: {
        data: Array<any>,
        isLoaded: Boolean
    };
    subjects: {
        data: Array<any>,
        isLoaded: Boolean
    };
    studentApplicationList: {
        data: Array<any>,
        isLoaded: Boolean
    };
    preEnlistmentList: {
        data: Array<any>,
        isLoaded: Boolean
    };
    studentAssessment: {
        data: Array<any>,
        isLoaded: Boolean
    };
    assessmentStudentList: {
        data: Array<any>,
        isLoaded: Boolean
    };
    studentLatestAssessment: {
        data: Array<any>,
        isLoaded: Boolean
    };
    studentSchedule: {
        data: Array<any>,
        isLoaded: Boolean
    };
}

export const initialState: State = {
    students: {
        data: [],
        isLoaded: false
    },
    studentFees: {
        data: [],
        isLoaded: false
    },
    studentPreinlistments: {
        data: [],
        isLoaded: false
    },
    gradeConverions: {
        data: [],
        isLoaded: false
    },
    subjects: {
        data: [],
        isLoaded: false
    },
    studentApplicationList: {
        data: [],
        isLoaded: false
    },
    preEnlistmentList: {
        data: [],
        isLoaded: false
    },
    studentAssessment: {
        data: [],
        isLoaded: false
    },
    assessmentStudentList: {
        data: [],
        isLoaded: false
    },
    studentLatestAssessment: {
        data: [],
        isLoaded: false
    },
    studentSchedule: {
        data: [],
        isLoaded: false
    },
}

export const reducer = createReducer(
    initialState,
    on(fromStudentActions.getStudentsSuccess, (state: State, props: any) => ({
        ...state,
        students: { data: props.data, isLoaded: true },
    })),
    on(fromStudentActions.getStudentFeesSuccess, (state: State, props: any) => ({
        ...state,
        studentFees: { data: props.data, isLoaded: true },
    })),
    on(fromStudentActions.getStudentPreinlistmentsSuccess, (state: State, props: any) => ({
        ...state,
        studentPreinlistments: { data: props.data, isLoaded: true },
    })),
    on(fromStudentActions.getGradeConversionsSuccess, (state: State, props: any) => ({
        ...state,
        gradeConverions: { data: props.data, isLoaded: true },
    })),
    on(fromStudentActions.getSubjectsSuccess, (state: State, props: any) => ({
        ...state,
        subjects: { data: props.data, isLoaded: true },
    })),
    on(fromStudentActions.getSubjectsSuccess, (state: State, props: any) => ({
        ...state,
        subjects: { data: props.data, isLoaded: true },
    })),
    on(fromStudentActions.getStudentApplicationListSuccess, (state: State, props: any) => ({
        ...state,
        studentApplicationList: { data: props.data, isLoaded: true },
    })),
    on(fromStudentActions.getPreEnlistmentListSuccess, (state: State, props: any) => ({
        ...state,
        preEnlistmentList: { data: props.data, isLoaded: true },
    })),
    on(fromStudentActions.getStudentAssessmentSuccess, (state: State, props: any) => ({
        ...state,
        studentAssessment: { data: props.data, isLoaded: true },
    })),
    on(fromStudentActions.getAssessmentStudentListSuccess, (state: State, props: any) => ({
        ...state,
        assessmentStudentList: { data: props.data, isLoaded: true },
    })),
    on(fromStudentActions.getStudentLatestAssessmentSuccess, (state: State, props: any) => ({
        ...state,
        studentLatestAssessment: { data: props.data, isLoaded: true },
    })),
    on(fromStudentActions.getStudentScheduleSuccess, (state: State, props: any) => ({
        ...state,
        studentSchedule: { data: props.data, isLoaded: true },
    })),
    // on(fromAuthActions.autoLogout, (state: State, props) => initialState),
);